import { url } from "inspector";
import http from "../../../NetworkServices/http";

let consoleBaseUrl = process.env.REACT_APP_CORE_API_BASE_URL;
consoleBaseUrl = consoleBaseUrl + "api/v1";

export class DealsNetworkService {
    // Create a new pipeline
    static createPipeline(pipelineData: { name: string; stages: any[] }) {
        const url = `${consoleBaseUrl}/${Endpoints.CREATE_PIPELINE}`;
        const res = http.post(url, pipelineData);
        return res
    }

    //get all pipelines
    static getAllPipelines() {
        const url = `${consoleBaseUrl}/${Endpoints.GET_PIPELINES}`;
        return http.get(url);
    }

    //update a pipeline with its stages
    static updatePipeline(pipelineId: string, pipelineData: { name: string; stages: any[] }) {
        const url = `${consoleBaseUrl}/${Endpoints.UPDATE_PIPELINE}/${pipelineId}`;
        return http.put(url, pipelineData)
    }

    //delete pipeline
    static deletePipeline(pipelineId: string) {
        const url = `${consoleBaseUrl}/${Endpoints.DELETE_PIPELINE}/${pipelineId}`;
        return http.delete(url)
    }


    //delete stage
    static deleteStage(pipelineId: string, stageId: string) {
        const url = `${consoleBaseUrl}/${Endpoints.DELETE_PIPELINE}/${pipelineId}/stage/${stageId}`;
        return http.delete(url)
    }


    //create or update lost reason
    static createLostReason(lostReasonData: { lost_reasons: any[] }) {
        const url = `${consoleBaseUrl}/${Endpoints.CREATE_LOST_REASON}`;
        return http.post(url, lostReasonData);

    }

    //get lost reasons
    static getLostReasons() {
        const url = `${consoleBaseUrl}/${Endpoints.GET_LOST_REASONS}`;
        return http.get(url);
    }

    //get lost reasons
    static getDealForm() {
        const url = `${consoleBaseUrl}/${Endpoints.GET_DEAL_FORM}`;
        return http.get(url);
    }

    //get lost reasons
    static setLostReasons(data: any) {
        const url = `${consoleBaseUrl}/${Endpoints.SET_LOST_REASONS}`;
        return http.post(url, data);
    }

    //get lost reasons
    static DeleteLostReasons(data: any) {
        const url = `${consoleBaseUrl}/${Endpoints.DELETE_LOST_REASONS}`;
        return http.post(url, data);
    }

    //get deal-list
    static getDealList( columns: string[], pipeline: string, deal_status: string, owner: string, search: string, offset: number, limit: number, contact_id: string) {
        const url = `${consoleBaseUrl}/${Endpoints.GET_DEAL_LIST}`;

        return http.post(url, { columns, pipeline, deal_status, owner, search, offset,limit, contact_id });
    }

    //create deal
    static createDeal(dealData: any) {
        const url = `${consoleBaseUrl}/${Endpoints.CREATE_DEAL}`;
        return http.post(url, dealData);

    }
    //Create deal note......
    static createDealNote(noteData: any) {
        const url = `${consoleBaseUrl}/${Endpoints.CREATE_DEAL_NOTE}`;
        return http.post(url, noteData);
    }

    //update deal by id..........
    static updateDealById(dealId: string, dealData: any) {
        const url = `${consoleBaseUrl}/${Endpoints.UPDATE_DEAL_BY_ID}/${dealId}`;
        return http.put(url, dealData)
    }

    //get deal by id............
    static getDealById(dealId: string) {
        const url = `${consoleBaseUrl}/${Endpoints.GET_DEAL_BY_ID}/${dealId}`;
        return http.get(url);
    }

    static deleteDeal(dealId: string) {
        const url = `${consoleBaseUrl}/${Endpoints.DELETE_DEAL}/${dealId}`;
        return http.delete(url)
    }

    // static getDealFormFields() {
    //     const url = `${consoleBaseUrl}/${Endpoints.GET_DEAL_FORM_FIELDS}`;
    //     // console.log("Deal data in network",);
    //     return http.get(url);

    // }

}

// Endpoints
class Endpoints {
    static CREATE_PIPELINE = "workspace/create-deal-pipeline";
    static GET_PIPELINES = "workspace/get-deal-pipeline";
    static UPDATE_PIPELINE = "workspace/update-deal-pipeline";
    static CREATE_LOST_REASON = "workspace/create-or-update-lost-reason";
    static GET_LOST_REASONS = "workspace/get-lost-reasons";
    static DELETE_PIPELINE = "workspace/delete-deal-pipeline";
    static DELETE_STAGE = "workspace/delete-deal-pipeline/stage";
    static GET_DEAL_LIST = "workspace/get-deals-list";
    static CREATE_DEAL = "workspace/create-deal";
    static GET_DEAL_FORM_FIELDS = "workspace/get-deal-form-fields";
    static SET_LOST_REASONS = "workspace/create-or-update-lost-reason";
    static DELETE_LOST_REASONS = "workspace/delete-lost-reason";
    static GET_DEAL_FORM = "workspace/get-deal-form-fields"
    static DELETE_DEAL = "workspace/delete-deal";
    static GET_DEAL_BY_ID = "workspace/get-deal-by-id";
    static UPDATE_DEAL_BY_ID = "workspace/update-deal";
    static CREATE_DEAL_NOTE = "workspace/create-deal-note";
}

